import { AppNode } from "@features/builder/graph/types"
import {
  expandedGroupMinHeight,
  expandedGroupMinWidth,
  groupPadding,
} from "@features/builder/helpers/nodes"

/** getNodeSize with padding */
export function getNodeSize(node: AppNode | undefined, deepthFromResized: number) {
  let width = expandedGroupMinWidth
  let height = expandedGroupMinHeight

  if (!node) return { width, height }

  // WIDTH
  if (node.width) width = node.width + groupPadding * deepthFromResized
  else if (node?.measured?.width) width = node?.measured?.width

  // HEIGHT
  if (node.height) height = node.height + groupPadding * deepthFromResized
  else if (node?.measured?.height) height = node?.measured?.height

  return { width, height }
}
